import { Component } from 'preact'
import WidgetPreview from '../components/widget-preview'
import {
    LayoutFilter,
    BackgroundFilter,
    ItemBackgroundFilter,
    ReviewItemFrameFilter,
    MinimalRatingFilter,
    OuterWrapperFrameFilter,
    ProfileFilters,
    LinkFilter,
} from '../components/filters'
import { __ } from '../../locales'

class WfGroupReviews extends Component {
    state = {
        selectedLayout: 'layoutA',
        layoutOptions: [
            {
                label: 'Group Reviews Layout A',
                value: 'layoutA'
            },
        ],
        selectedProfiles: []
    };

    render(props, state) {
        return (
            <WidgetPreview
                {...props}
                name={__('widget.group_reviews.name')}
                type={'group-reviews-widget'}
                extraParams={[
                    'slugs',
                    'background',
                    'itemBackground',
                    'outerFrame',
                    'itemFrame',
                    'rating',
                ]}
                layoutType={state.selectedLayout}
                badgeTitle={__('widget.type.carousel')}
                badgeColor={'#2B59E0'}
                badgeFontColor={'#FFFFFF'}
            >
                <div className={'filters-wrapper mt-5 mb-5'}>
                    <ProfileFilters
                      {...props}
                      profileTypes={['practice']}
                    />
                    <LayoutFilter
                        selectedLayout={state.selectedLayout}
                        options={state.layoutOptions}
                        onChange={ev => this.setState({ selectedLayout: ev.target.value })}
                    />
                    <LinkFilter {...props} required={props.selectedProfiles.length > 1} />
                    <BackgroundFilter {...props} />
                    <ItemBackgroundFilter {...props} />
                    <ReviewItemFrameFilter {...props} />
                    <OuterWrapperFrameFilter {...props} />
                    <MinimalRatingFilter {...props} />
                </div>
            </WidgetPreview>
        );
    }
}

export default WfGroupReviews
